module.exports = __webpack_public_path__ + "31844c2585f8eaf01d6478d3783bc35f.svg";